import { jsxs, jsx } from 'react/jsx-runtime';
import { DropdownItemIconContainer } from '@fabric-app/ui/components/DropdownMenu/Item';
import { resourceTagsModal } from '../../../../tags/components/ModalResourceTags/resourceTagsStore.js';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import { useContextAccessToken } from '../../../../permission/contexts/AnonShareTokenContext.js';
import { useResourceDataContextSafe } from '../../../../resource-detail/components/context/resourceDataContext.js';
import { IconTag } from '@fabric-app/icons/svg';

const ContextItemUpdateTags = () => {
  const accessToken = useContextAccessToken();
  const { resource } = useResourceDataContextSafe();
  if (accessToken) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ContextMenu.Item, {
    onClick: () => {
      resourceTagsModal.open({
        resourceId: resource.id
      });
    },
    "data-testid": "item-context-menu-edit-tags-button",
    children: [
      /* @__PURE__ */ jsx(DropdownItemIconContainer, {
        children: /* @__PURE__ */ jsx(IconTag, {})
      }),
      "Add/edit tags"
    ]
  });
};

export { ContextItemUpdateTags };
//# sourceMappingURL=ContextItemUpdateTags.js.map
